import React, { useState } from "react";
import { toast } from "react-toastify";
import "../styles/Configuracoes.css";
import { criarUsuarioComLogin } from "../services/criar-usuario.service"; // Edge Function A5

const PAPEIS = ["Admin", "Líder"];
// Rótulo da UI -> valor de profiles.role
const PAPEL_ROLE = { Admin: "admin", Líder: "lider" };

export default function Configuracoes() {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [papel, setPapel] = useState("Líder");
  // Admin/líder que também dá aula (caso Alex/Marco): cria a linha em
  // professores junto — aparece na Pré-sala e opera a própria Sala.
  const [tambemProfessor, setTambemProfessor] = useState(false);
  const [criando, setCriando] = useState(false);

  // Criação real via Edge Function criar-professor (A5) — a function exige
  // caller admin pra papel admin/líder. Só Marco e Daniel serão admin de fato.
  const handleCriar = async (e) => {
    e.preventDefault();
    if (!nome.trim() || !email.trim()) {
      toast.error("Nome e email são obrigatórios.");
      return;
    }
    if (senha.length < 6) {
      toast.error("Senha provisória precisa de pelo menos 6 caracteres.");
      return;
    }

    setCriando(true);
    try {
      await criarUsuarioComLogin({
        nome,
        email,
        senha,
        papel: PAPEL_ROLE[papel],
        tambemProfessor,
      });
      toast.success(
        `${papel} ${nome} criado com login ativo. A senha provisória deve ser trocada no primeiro acesso.`
      );
      setNome("");
      setEmail("");
      setSenha("");
      setPapel("Líder");
      setTambemProfessor(false);
    } catch (err) {
      console.error("Erro ao criar usuário:", err);
      toast.error("Erro ao criar usuário: " + err.message);
    } finally {
      setCriando(false);
    }
  };

  return (
    <div className="config-nova">
      <h1>Configurações</h1>

      <div className="config-grid">
        <div className="cfg-card">
          <h2>Adicionar Admin / Líder</h2>
          <p className="cfg-nota">
            Restrito a admin. Só Marco e Daniel serão admin — recepção não
            acessa esta tela.
          </p>

          <form onSubmit={handleCriar}>
            <label className="cfg-field">
              <span>Nome completo</span>
              <input
                type="text"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                placeholder="Nome da pessoa"
              />
            </label>

            <label className="cfg-field">
              <span>Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@ironhouse.com"
              />
            </label>

            <label className="cfg-field">
              <span>Senha provisória</span>
              <input
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="A pessoa troca no primeiro acesso"
              />
            </label>

            <div className="cfg-section-title cfg-mt">Papel</div>
            <div className="cfg-pillset">
              {PAPEIS.map((op) => (
                <button
                  type="button"
                  key={op}
                  className={`cfg-pill ${op === papel ? "active" : ""}`}
                  onClick={() => setPapel(op)}
                >
                  {op}
                </button>
              ))}
            </div>

            <label className="cfg-field cfg-check cfg-mt">
              <input
                type="checkbox"
                checked={tambemProfessor}
                onChange={(e) => setTambemProfessor(e.target.checked)}
              />
              <span>
                Também dá aula (cria como professor — aparece na Pré-sala e
                opera a própria Sala)
              </span>
            </label>

            <button
              type="submit"
              className="cfg-btn-primary cfg-mt"
              disabled={criando}
            >
              {criando ? "Criando..." : "Criar usuário"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
